import styled from 'styled-components'
import { H3 } from '../../../../typography'
import { colors } from '../../../../const/theme'

export const SubjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Videos = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  @media (max-width: 415px) {
    justify-content: space-evenly;
  }
  & > div {
    margin: 0 !important;
  }
`

export const VideoPlayerWrapper = styled.div`
  margin: 0 auto;
`

export const Materials = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  @media (max-width: 415px) {
    justify-content: space-evenly;
  }
  & > div {
    margin: 0 !important;
    max-width: 100px;
  }
`

export const MaterialTitle = styled(H3)`
  padding: 16px 24px;
  border-radius: 15px;
  background: ${colors.active};
  color: ${colors.black};
  margin-top: 12px;
`

export const ListItemWrapper = styled.ul`
  padding: 0;
`

export const MaterialWrapper = styled.div`
  padding: 12px;
`
